import { Table, TableHead, TableRow, TableHeaderCell, TableBody, TableCell } from 'react-magma-dom';
import { getVersions } from "../../../../src/utils";
import * as React from 'react';
export default {
  Table,
  TableHead,
  TableRow,
  TableHeaderCell,
  TableBody,
  TableCell,
  getVersions,
  React
};